<script setup lang="ts">
import DolphinChip from '@/components/atoms/DolphinChip.vue'
import {
  getQuestionStatusName,
  type SelectBoxQuestion,
} from '../calendarQuestion'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import { computed, ref } from 'vue'

const { question, formError } = defineProps<{
  question: SelectBoxQuestion
  formError: string | undefined
}>()

const statusName = computed(() => getQuestionStatusName(question.status))
// サンプル表示のために選択肢の値を保持
const value = ref('')
</script>
<template>
  <div :class="$style.input">
    <div :class="$style.questionText">
      <div :class="$style.questionText__label">
        <label :class="$style.questionText__labelText">
          <template v-if="question.questionText !== ''">
            {{ question.questionText }}
          </template>
          <span v-else :class="$style['questionText__labelText--warning']">
            この質問を選択して質問内容を編集してください
          </span>
        </label>
        <DolphinChip :class="$style.questionText__chip">{{
          statusName
        }}</DolphinChip>
      </div>
      <DolphinSelector
        :options="question.options.map(s => ({ value: s, text: s }))"
        v-model="value"
      />
      <p v-if="formError" :class="$style.questionText__error">
        {{ formError }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.questionText {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 24px;
  }

  &__labelText {
    font-size: 16px;
    line-height: 1;
    font-weight: bold;

    &--warning {
      color: $color-text-and-object-accent-red;
    }
  }

  &__chip {
    color: $color-text-and-object-high-emphasis;
    background-color: $color-surface-secondary;
  }

  &__error {
    color: $color-caution-accent;
    font-size: 12px;
  }
}
</style>
